//main
import ContentFormatXW from "../content/webc/content-format-xw";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import XummModule from "../content/xumm/xumm-connect";

export default function Xumm() {

  return (
  <>
    <ContentFormatXW 
      head='Users'
      link={`/home`}
      form= 'full'
      data= {
        <>
          <WebbDividerSmall />
          <XummModule />


        </>
      } 
    />
  </>
  )
}